import { EChartsOption, SeriesOption } from 'echarts';
import { COLOR_SCALES } from 'styles/theme';

export const DEFAULT_OPTIONS: EChartsOption = {
    textStyle: { fontFamily: 'Poppins' },
    color: COLOR_SCALES.manty,
    tooltip: {
        trigger: 'item',
        confine: true,
    },
    legend: {
        orient: 'horizontal',
        left: 'center',
        right: 'auto',
        top: 'auto',
        itemWidth: 14,
        type: 'scroll',
    },
    grid: {
        left: '5%',
        bottom: '2%',
        containLabel: true,
    },
};
function extractStackType(str: string): string | null {
    const match = str.match(/Montant (\S+)/);
    return match ? match[1].charAt(0).toUpperCase() + match[1].slice(1) : null; // match[1] contains the captured word
}
export const currencyFormatter = (value: number | string): string =>
    typeof value === 'number'
        ? `${Number(value.toFixed(2)).toLocaleString()} €`
        : value;

export const tooltipFormatter = (
    params: any,
    series: SeriesOption[],
    formattedDates: string[],
): string => {
    // used to display the total amount and the current amount
    const seriesNames = series.map((serie: SeriesOption) => serie.name);
    let seriesName = seriesNames[params.seriesIndex || 0]; // Get the series name
    let stackType = '';
    if (typeof seriesName === 'string') {
        stackType = extractStackType(seriesName) ?? '';
        seriesName = seriesName.replace(/ - Montant .*/, '');
    }
    // Calculate the total for the same dataIndex across all series
    const total = series.reduce((acc, serie) => {
        const data = serie.data as number[];

        return acc + (data[params.dataIndex] || 0);
    }, 0);

    return `<div style="text-align: center; line-height: 2.6;">
    <span style="font-weight: 600;">${stackType} ${
        formattedDates[params.dataIndex]
    } </span> ${currencyFormatter(total)}<br/>${
        params.marker
    } <span style="font-weight: 600;">${seriesName}</span>  ${currencyFormatter(
        params.value,
    )}</div>`;
};
